import { Pipe, PipeTransform } from '@angular/core';
import { EventStatus, League } from '@model';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({ name: 'leagueNextRound' })
export class LeagueNextRoundPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (value?: League): string => {
    const round = value ? (value.events?.length ?? 0) - this.calculateEventsToGo(value) + 1 : 0;
    return this.translocoService.translate('league.round', { value: round });
  }

  private calculateEventsToGo = (league?: League): number =>
    league?.events?.reduce((count, item) => item.status === EventStatus.ACTIVE ? count + 1 : count, 0) ?? 0;
}
